import * as React from 'react';
import { EventIndexView } from '../../../../types/events';
import { Button } from '../../../../../commonv3/components/atoms/buttons/Button';
import { observer } from 'mobx-react';
import { EventWaitlistState } from '../states/EventWaitlistState';
import { EventDetails } from '../../../../../mainv2/types/event';

type EventWaitlistToggleButtonProps = {
  event: EventIndexView | EventDetails;
  reserved: boolean;
  eventWaitlistState: EventWaitlistState;
};

export const EventWaitlistToggleButton = observer(
  ({ event, reserved, eventWaitlistState }: EventWaitlistToggleButtonProps) => {
    const { submitting, eventWaitlists, createEventWaitingList, cancelEventWaitingList, canShowWaitlist, success } =
      eventWaitlistState;
    const eventWaitlist = eventWaitlists.getOrElse([]).find((waitlist) => waitlist.event_id === event.id);
    if (!canShowWaitlist(event, reserved)) {
      return null;
    }
    if (eventWaitlist) {
      if (success) {
        return (
          <Button type="success" size="l">
            通知解除が完了しました
          </Button>
        );
      } else {
        return (
          <Button
            id="waitlist-cancel-button"
            type="notify"
            size="l"
            loading={submitting}
            disabled={submitting}
            onClick={() => cancelEventWaitingList(eventWaitlist.id)}
          >
            空き枠通知を解除する
          </Button>
        );
      }
    } else {
      if (success) {
        return (
          <Button type="success" size="l">
            通知設定が完了しました
          </Button>
        );
      } else {
        return (
          <Button
            id="waitlist-button"
            type="primary"
            size="l"
            loading={submitting}
            disabled={submitting}
            onClick={() => createEventWaitingList(event.id)}
          >
            空き枠通知をする
          </Button>
        );
      }
    }
  }
);
